import * as Yup from "yup";
import { IMapUserToExternalUser } from "../../../services/medicationmanagement/userRegistration/models/MapUserToExternalUser";
import { validateMedicareProviderNumber } from '../../common/utils/validations';

export const PrescriberSchema = Yup.object<Partial<Record<keyof IMapUserToExternalUser, Yup.AnySchema>>>({
  hpiiNumber: Yup.string()
    .required("HPI-I number is a required field")
    .matches(/^[0-9]+$/, "HPI-I must be only digits")
    .min(16, "HPI-I must be 16-digit number")
    .max(16, "HPI-I must be 16-digit number"),
  prescriberNumber: Yup.string()
    .required("Prescriber number is a required field")
    .matches(/^[0-9]+$/, "Prescriber number must be only digits")
    .max(7, "Prescriber number must be less than or equal to 7 digits")
});

export const PharmacistSchema = Yup.object<Partial<Record<keyof IMapUserToExternalUser, Yup.AnySchema>>>({
  hpiiNumber: Yup.string()
  .required("HPI-I number is a required field")
  .matches(/^[0-9]+$/, "HPI-I must be only digits")
  .min(16, "HPI-I must be 16-digit number")
  .max(16, "HPI-I must be 16-digit number")
});

